import { Locale, translate } from "./translations";

const ru: Locale = {
  welcome: "Добро пожаловать в APAATO",
  signIn: "Войти",
  register: "Регистрация",
  accountType: "Тип аккаунта",
  accountTypeUser: "Пользователь",
  accountTypePartner: "Партнёр",
  firstName: "Имя",
  lastName: "Фамилия",
  orgName: "Название организации",
  createAccount: "Создать аккаунт",
  registrationRequired: "Пожалуйста, завершите регистрацию, чтобы продолжить.",
  signOut: "Выйти",
  greeting: (name: string) => `Привет, ${name}`,
  email: "Эл. почта",
  password: "Пароль",
  continueWithGoogle: "Войти через Google",
  pleaseWait: "Пожалуйста, подождите...",
  fillAllFields: "Пожалуйста, заполните все поля.",
  userNotFound: "Пользователь с таким email не найден.",
  wrongPassword: "Неверный пароль.",
  authFailed: "Ошибка аутентификации. Попробуйте ещё раз.",
  signInCancelled: "Процесс входа был отменён.",
  googleSignInFailed: "Не удалось войти через Google. Попробуйте ещё раз.",
  notAuthorized: "Ваш аккаунт не авторизован для доступа к этой среде.",
  registrationFailed: "Регистрация не удалась. Попробуйте ещё раз.",

  confirmPassword: "Подтвердите пароль",
  accountTypeUserHint: "Хочу найти квартиру в Японии",
  accountTypePartnerHint: "Хочу размещать объявления о жилье",
  show: "Показать",
  hide: "Скрыть",
  emailRequired: "Email обязателен",
  emailInvalid: "Введите корректный email",
  passwordRequired: "Пароль обязателен",
  passwordMin8: "Пароль должен быть не короче 8 символов",
  passwordNeedNumber: "Пароль должен содержать хотя бы одну цифру",
  passwordNeedSymbol: "Пароль должен содержать хотя бы один символ",
  passwordNeedUpper: "Пароль должен содержать хотя бы одну заглавную букву",
  passwordNeedLower: "Пароль должен содержать хотя бы одну строчную букву",

  passwordRequirements: "Требования к паролю",
  passwordReqMin8: "Не менее 8 символов",
  passwordReqNumber: "Хотя бы 1 цифра",
  passwordReqSymbol: "Хотя бы 1 символ",
  passwordReqUpper: "Хотя бы 1 заглавная буква",
  passwordReqLower: "Хотя бы 1 строчная буква",

  notVerified: "Пожалуйста, подтвердите email перед входом.",
  forbidden: "Доступ к этой среде запрещён.",

  confirmPasswordRequired: "Подтвердите пароль",
  passwordsDontMatch: "Пароли не совпадают",
  firstNameRequired: "Имя обязательно",
  lastNameRequired: "Фамилия обязательна",
  orgNameRequired: "Название организации обязательно",

  // Email verification flow
  verificationSentTitle: "Подтвердите email",
  verificationSentBody: (email: string) =>
    `Мы отправили письмо на ${email}. Пожалуйста, проверьте почту и перейдите по ссылке для подтверждения аккаунта.`,
  okGotIt: "Понятно",
  emailConfirmedTitle: "Email подтверждён",
  emailConfirmedBody:
    "Спасибо! Ваш email подтверждён. Теперь вы можете войти в аккаунт.",
  logIntoAccount: "Войти в аккаунт",

  // Verification page
  verificationFailedTitle: "Ошибка подтверждения",
  verificationExpired:
    "Срок действия этой ссылки истёк. Пожалуйста, запросите новую.",
  verificationInvalid: "Эта ссылка недействительна или уже была использована.",
  verificationFailed: "Не удалось подтвердить email. Попробуйте позже.",
  verificationMissingCodeTitle: "Код подтверждения отсутствует",
  verificationMissingCodeBody:
    "Код подтверждения не указан. Пожалуйста, нажмите на ссылку из письма ещё раз.",
  backToLogin: "Вернуться к входу",
  resendVerificationEmail: "Отправить письмо повторно",
  resendVerificationHint: (email: string) =>
    `Отправить новую ссылку для подтверждения на ${email}?`,
  verificationResent: "Письмо отправлено. Проверьте почту.",
  resendFailed: "Не удалось отправить письмо. Попробуйте ещё раз.",

  // Homepage
  dashboard: "Панель управления",
  homeHeroTitle: "Найдите идеальное жильё в Японии",
  homeHeroSubtitle:
    "Качественные квартиры в Токио для иностранцев и местных жителей.",
  searchPrefecture: "Префектура",
  searchSelectPrefecture: "Выберите префектуру",
  searchCity: "Город",
  searchSelectCity: "Выберите город",
  searchLocation: "Район",
  searchSelectArea: "Выберите район",
  searchMoveIn: "Дата заселения",
  searchMoveInPlaceholder: "Выберите дату",
  searchOccupants: "Проживающих",
  searchRentBudget: "Месячный бюджет",
  searchRoomLayout: "Планировка",
  searchPerson: "человек",
  searchPeople: "человек",
  searchButton: "Найти квартиры",
  searchEditCriteria: "Редактировать поиск",
  featureQualityTitle: "Качественное жильё",
  featureQualityDesc: "Каждое объявление проверено на качество и комфорт.",
  featureTrustedTitle: "Надёжные партнёры",
  featureTrustedDesc: "Работаем с проверенными агентствами и арендодателями.",
  featureSupportTitle: "Местная поддержка",
  featureSupportDesc: "Многоязычная команда поможет вам освоиться.",
  disclaimerTitle: "MVP в разработке",
  disclaimerBody:
    "Это ранняя версия MVP. Функция поиска и список объектов появятся скоро. Пока поддерживается только район Токио.",
  footerRights: "Все права защищены.",

  // Philosophy Section
  philosophyTitle: "Наша философия",
  philosophySubtitle:
    "Мы хотим упростить поиск квартиры в Японии для иностранцев.",
  philosophyNoFeesTitle: "Без скрытых платежей",
  philosophyNoFeesDesc:
    "Полная прозрачность цен. То, что вы видите — это то, что вы платите. Никаких сюрпризов.",
  philosophySimpleTitle: "Простой интерфейс",
  philosophySimpleDesc:
    "Чистый и интуитивно понятный дизайн, который делает поиск жилья лёгким.",
  philosophyQualityTitle: "Качественные объявления",
  philosophyQualityDesc:
    "Качественные объявления со всей необходимой информацией о недвижимости и квартирах.",
  philosophyVerifiedTitle: "Проверенные риелторы",
  philosophyVerifiedDesc:
    "Работаем только с надёжными, проверенными специалистами по недвижимости.",

  // Snackbar messages
  welcomeUserSnackbar:
    "Добро пожаловать! Функции панели управления скоро появятся.",
  welcomeAdminSnackbar: "С возвращением, администратор!",

  // Dashboard
  dashboardWelcome: "С возвращением",
  dashboardSubtitle: "Управляйте поиском квартир и сохранёнными объявлениями.",
  dashboardSearch: "Поиск",
  dashboardSearchDesc: "Найти квартиры в Токио",
  dashboardFavorites: "Избранное",
  dashboardFavoritesDesc: "Просмотр сохранённых объявлений",
  dashboardNotifications: "Уведомления",
  dashboardNotificationsDesc: "Обновления по вашим поискам",
  dashboardSettings: "Настройки",
  dashboardSettingsDesc: "Управление аккаунтом",
  dashboardComingSoon: "Функции в разработке",
  dashboardComingSoonDesc:
    "Эти функции сейчас в разработке. Скоро будут доступны!",
  dashboardDevTools: "Инструменты разработчика",
  dashboardDevToolsDesc: "Доступ к API для тестирования и разработки",
  dashboardTokenInfo: "Используйте ID-токен для аутентификации API-запросов в",
  dashboardShowToken: "Показать токен",
  dashboardCopyToken: "Копировать токен",
  dashboardCopied: "Скопировано!",
  dashboardTokenError: "Не удалось получить токен. Обновите страницу.",

  // Overview Page
  back: "Назад",
  overviewSearchingIn: "Поиск в",
  overviewListView: "Список",
  overviewMapView: "Карта",
  overviewResultsTitle: "Результаты поиска",
  overviewNoResults: "Найдено 0 квартир",
  overviewEmptyTitle: "Квартиры не найдены",
  overviewEmptyDesc:
    "Измените фильтры или условия поиска. Данные будут добавлены в ближайшее время.",
  overviewMapTitle: "Просмотр на карте",
  overviewMapComingSoon: "Карта скоро появится",
  overviewMapComingSoonDesc:
    "Интерактивная карта с расположением квартир станет доступна в будущем обновлении.",
  overviewLoading: "Поиск квартир...",
  overviewResults: "квартир найдено",
  overviewErrorTitle: "Что-то пошло не так",
  overviewRetry: "Повторить",
  overviewLoadingMore: "Загрузка...",
  overviewLoadMore: "Загрузить ещё",

  // Listing Card
  "listings.min": "мин",
  "listings.month": "мес",
  "listings.foreignerFriendly": "Иностр. OK",
  "listings.petsAllowed": "Питомцы OK",
  "listings.airConditioning": "Кондиц.",
  "listings.deposit": "Депозит",
  "listings.keyMoney": "Ключ.",

  // Filters
  filtersTitle: "Фильтры",
  filterReset: "Сбросить",

  // Filter Categories
  filterCategoryProperty: "Тип недвижимости",
  filterCategoryPrice: "Цена и сборы",
  filterCategorySize: "Размер и планировка",
  filterCategoryAmenities: "Удобства",
  filterCategoryBuilding: "Здание",
  filterCategoryAccess: "Транспорт",
  filterCategoryContract: "Условия договора",

  // Property Types
  filterPropertyType: "Тип недвижимости",
  filterPropertyApartment: "Апартаменты",
  filterPropertyMansion: "Мансион",
  filterPropertyShareHouse: "Шеа-хаус",
  filterPropertyGuestHouse: "Гестхаус",
  filterPropertyMonthlyMansion: "Помесячный мансион",

  // Room Layouts
  filterRoomLayout: "Планировка",
  filterLayout1R: "1R",
  filterLayout1K: "1K",
  filterLayout1DK: "1DK",
  filterLayout1LDK: "1LDK",
  filterLayout2K: "2K",
  filterLayout2DK: "2DK",
  filterLayout2LDK: "2LDK",
  filterLayout3K: "3K",
  filterLayout3DK: "3DK",
  filterLayout3LDKPlus: "3LDK+",

  // Price Filters
  filterMinRent: "Мин. аренда",
  filterMaxRent: "Макс. аренда",
  filterIncludeManagementFee: "Включая коммунальные",
  filterKeyMoney: "Ключевые деньги",
  filterDeposit: "Депозит",
  filterGuarantor: "Гарант",
  filterNoKeyMoney: "Без ключевых денег",
  filterNoDeposit: "Без депозита",
  filterHalfMonth: "0.5 месяца",
  filter1Month: "1 месяц",
  filter2Months: "2 месяца",
  filterAny: "Любой",
  filterYes: "Да",
  filterNo: "Нет",

  // Size Filters
  filterMinSize: "Мин. площадь",
  filterMaxSize: "Макс. площадь",

  // Amenities
  filterAirConditioning: "Кондиционер",
  filterWasherHookup: "Подключение стиралки",
  filterWasherDryerInUnit: "Стиралка/сушилка в квартире",
  filterBathToiletSeparate: "Раздельный санузел",
  filterBalcony: "Балкон",
  filterFlooringWood: "Деревянный пол",
  filterInternetIncluded: "Интернет включён",
  filterGasStove: "Газовая плита",
  filterIHCooktop: "IH-плита",

  // Building
  filterBuildingAge: "Возраст здания",
  filterAnyAge: "Любой",
  filterUnder5Years: "До 5 лет",
  filterUnder10Years: "До 10 лет",
  filterUnder20Years: "До 20 лет",
  filterUnder30Years: "До 30 лет",
  filterFloor: "Этаж",
  filterAnyFloor: "Любой",
  filterFirstFloor: "1-й этаж",
  filter2ndFloorPlus: "2-й этаж+",
  filter3rdFloorPlus: "3-й этаж+",
  filterTopFloor: "Последний этаж",
  filterElevator: "Лифт",
  filterAutoLock: "Автозамок",
  filterDeliveryBox: "Постамат",
  filterParking: "Есть парковка",
  filterBicycleParking: "Велопарковка",

  // Access
  filterWalkToStation: "До станции пешком",
  filterAnyWalkTime: "Любое расстояние",
  filterWithin5Min: "До 5 мин",
  filterWithin10Min: "До 10 мин",
  filterWithin15Min: "До 15 мин",
  filterWithin20Min: "До 20 мин",

  // New categories
  filterCategoryBathroom: "Ванная и стирка",
  filterCategoryKitchen: "Кухня",
  filterCategorySecurity: "Безопасность",
  filterCategoryListing: "Объявление",

  // Bathroom & Laundry
  filterIndoorWasherSpace: "Место для стиральной машины",
  filterReheatingBath: "Подогрев ванны",
  filterBathroomDryer: "Сушилка в ванной",
  filterWashletSeat: "Биде-сиденье",
  filterIndependentVanity: "Отдельная раковина",

  // Kitchen
  filterSystemKitchen: "Системная кухня",
  filterCounterKitchen: "Кухня с барной стойкой",
  filterDishwasher: "Посудомоечная машина",

  // Building extras
  filterSouthFacing: "Южная сторона",
  filterCornerUnit: "Угловая квартира",
  filterBuildingStructure: "Конструкция здания",
  filterStructureRC: "Железобетон",
  filterStructureSteel: "Стальной каркас",
  filterStructureWood: "Дерево",
  filterStructureSRC: "Стальной железобетон",

  // Security
  filterSecurityCamera: "Камера наблюдения",
  filterVideoIntercom: "Видеодомофон",

  // Parking extras
  filterMotorcycleParking: "Парковка для мотоцикла",

  // Contract
  filterForeignerFriendly: "Для иностранцев",
  filterPetsAllowed: "Животные разрешены",
  filterInstrumentsOK: "Музыкальные инструменты",
  filterSohoOK: "Офис/SOHO",
  filterNoGuarantorNeeded: "Без поручителя",
  filterMoveInWithin30Days: "Заезд в течение 30 дней",

  // Listing freshness
  filterListingFreshness: "Дата публикации",
  filterFreshnessAny: "Любое время",
  filterFreshness24h: "За последние 24 часа",
  filterFreshness3d: "За последние 3 дня",
  filterFreshness7d: "За последние 7 дней",
  filterFreshness14d: "За последние 14 дней",

  // Theme switcher
  themeSwitchToLight: "Переключить на светлую тему",
  themeSwitchToDark: "Переключить на тёмную тему",

  // Partner type
  partnerType: "Тип партнёра",
  partnerTypeIndividual: "Физическое лицо",
  partnerTypeIndividualHint: "Работаю самостоятельно",
  partnerTypeOrganization: "Организация",
  partnerTypeOrganizationHint: "Представляю компанию",

  // Profile Page
  profileWelcome: "С возвращением",
  profileSubtitle: "Управляйте профилем, объявлениями и настройками.",
  profileSearch: "Поиск",
  profileSearchDesc: "Найти квартиры в Токио",
  profileMyListings: "Мои объявления",
  profileMyListingsDesc: "Управление опубликованными объявлениями",
  profileFavorites: "Избранное",
  profileFavoritesDesc: "Просмотр сохранённых объявлений",
  profileNotifications: "Уведомления",
  profileNotificationsDesc: "Обновления аккаунта",
  profileSettings: "Настройки",
  profileSettingsDesc: "Управление аккаунтом",
  profileComingSoon: "Функции в разработке",
  profileComingSoonDesc:
    "Избранное, уведомления и настройки находятся в разработке.",
  profileCreateListing: "Новое объявление",
  profileIndividual: "Индивидуальный партнёр",
  backToProfile: "Назад к профилю",

  // Create/Edit Listing Page
  createListingTitle: "Создать объявление",
  editListingTitle: "Редактировать объявление",
  createListingSubtitle: "Заполните данные для публикации объявления",
  createListingPartnerOnly: "Только партнёры могут создавать объявления",
  createListingBasicInfo: "Основная информация",
  createListingTitleField: "Заголовок объявления",
  createListingTitlePlaceholder:
    "Например: Просторная 1LDK рядом со станцией Shibuya",
  createListingDescription: "Описание",
  createListingDescPlaceholder:
    "Опишите особенности квартиры, удобства и район...",
  createListingLocation: "Местоположение",
  createListingCityPlaceholder: "Например: Токио",
  createListingWard: "Район",
  createListingAddress: "Адрес",
  createListingStation: "Ближайшая станция",
  createListingStationPlaceholder: "Например: станция Shibuya",
  createListingWalkMinutes: "Пешком до станции (мин)",
  createListingPricing: "Цены",
  createListingPrice: "Месячная аренда (¥)",
  createListingManagementFee: "Коммунальные (¥)",
  createListingBuilding: "Информация о здании",
  createListingArea: "Площадь (м²)",
  createListingTotalFloors: "Всего этажей",
  createListingYearBuilt: "Год постройки",
  createListingAvailableFrom: "Доступно с",
  createListingPhotos: "Фотографии",
  createListingPhotosHelp:
    "Загрузите фотографии для каждой секции. Для публикации требуется минимум 5 изображений.",
  createListingPhotosComingSoon: "Загрузка фото скоро будет доступна",
  createListingImageUploadError: "Не удалось загрузить изображения",
  createListingSaveDraft: "Сохранить черновик",
  createListingPublish: "Опубликовать",
  createListingSaved: "Объявление сохранено как черновик",
  createListingPublished: "Объявление опубликовано",
  createListingError: "Не удалось создать объявление. Попробуйте ещё раз.",
  createListingValidationError: "Заполните все обязательные поля",
  validationErrors: "Пожалуйста, исправьте следующие ошибки:",
  createListingTitleRequired: "Заголовок обязателен",
  createListingTitleMinLength: "Заголовок должен быть не менее 5 символов",
  createListingPropertyTypeRequired: "Тип недвижимости обязателен",
  createListingRoomLayoutRequired: "Планировка обязательна",
  createListingPrefectureRequired: "Префектура обязательна",
  createListingCityRequired: "Город обязателен",
  createListingPriceRequired: "Цена должна быть больше 0",
  createListingMinImagesRequired:
    "Для публикации требуется минимум 5 изображений",
  createListingAddressHint:
    "Введите полный адрес, включая название здания и номер квартиры.",
  createListingInvalidAddress: "Неверный адрес",
  createListingAddressValidationError: "Произошла ошибка при проверке адреса",
  createListingValidatingAddress: "Проверка адреса...",
  createListingValidating: "Проверка...",
  createListingValidate: "Проверить адрес",

  // My Listings Page
  myListingsTitle: "Мои объявления",
  myListingsSubtitle: "Управление опубликованными и черновыми объявлениями",
  myListingsPublishedTab: "Опубликованные и история",
  myListingsDraftsTab: "Черновики",
  myListingsEmpty: "Нет объявлений",
  myListingsEmptyDesc: "Создайте своё первое объявление",
  myListingsEmptyPublished: "Нет опубликованных объявлений",
  myListingsEmptyPublishedDesc:
    "Опубликуйте черновик или создайте новое объявление.",
  myListingsEmptyDrafts: "Нет черновиков",
  myListingsEmptyDraftsDesc: "Все ваши объявления опубликованы Создайте новое.",
  myListingsCreateFirst: "Создать первое объявление",
  myListingsPublished: "Опубликовано",
  myListingsDraft: "Черновик",
  myListingsExpired: "Снято с публикации",
  myListingsEdit: "Редактировать",
  myListingsDelete: "Удалить",
  myListingsDeleteTitle: "Удалить объявление",
  myListingsDeleteMessage:
    "Вы уверены, что хотите удалить это объявление? Это действие нельзя отменить.",
  myListingsDeleteConfirm: "Удалить",
  myListingsDeleted: "Объявление удалено",
  myListingsDeleteError: "Не удалось удалить объявление",
  myListingsLoadError: "Не удалось загрузить объявления",
  myListingsUnpublish: "Снять с публикации",
  myListingsRepublish: "Опубликовать снова",
  myListingsPublishAction: "Опубликовать",
  myListingsStatusUpdated: "Статус объявления обновлён",
  myListingsStatusUpdateError: "Не удалось обновить статус объявления",

  // Settings Page
  settingsTitle: "Настройки",
  settingsSubtitle: "Управляйте настройками аккаунта и предпочтениями",
  settingsProfilePicture: "Фото профиля",
  settingsPhotoComingSoon: "Загрузка фото скоро будет доступна",
  settingsPersonalInfo: "Личная информация",
  settingsPhone: "Номер телефона",
  settingsEmailReadOnly: "Email нельзя изменить",
  settingsOrganization: "Организация",
  settingsOrgReadOnly: "Свяжитесь с поддержкой для изменения организации",
  settingsSecurity: "Безопасность",
  settingsChangePasswordDesc: "Измените пароль, введя текущий и новый пароль",
  settingsCurrentPassword: "Текущий пароль",
  settingsNewPassword: "Новый пароль",
  settingsChangePassword: "Изменить пароль",
  settingsPasswordChanged: "Пароль успешно изменён",
  settingsCurrentPasswordWrong: "Неверный текущий пароль",
  settingsPasswordTooWeak: "Новый пароль слишком слабый",
  settingsReauthRequired:
    "Пожалуйста, выйдите и войдите снова перед сменой пароля",
  settingsPasswordChangeError:
    "Не удалось изменить пароль. Попробуйте ещё раз.",
  settingsSave: "Сохранить изменения",
  settingsSaved: "Настройки сохранены",
  settingsSaveError: "Не удалось сохранить настройки. Попробуйте ещё раз.",
  settingsLoadError: "Не удалось загрузить настройки",

  // Reset Password Page
  resetPasswordTitle: "Сброс пароля",
  resetPasswordSubtitle: "Введите новый пароль для вашего аккаунта:",
  resetPasswordNewPassword: "Новый пароль",
  resetPasswordSuccessTitle: "Пароль успешно изменён",
  resetPasswordSuccessBody:
    "Ваш пароль успешно изменён. Теперь вы можете войти с новым паролем.",
  resetPasswordMissingCodeTitle: "Отсутствует код сброса",
  resetPasswordMissingCodeBody:
    "Код сброса пароля не предоставлен. Перейдите по ссылке из письма для сброса пароля.",
  resetPasswordFailedTitle: "Сброс пароля не удался",
  resetPasswordExpired:
    "Срок действия этой ссылки истёк. Запросите новую ссылку на странице входа.",
  resetPasswordInvalid: "Эта ссылка недействительна или уже была использована.",
  resetPasswordFailed: "Не удалось сбросить пароль. Попробуйте позже.",
  resetPasswordSubmit: "Сбросить пароль",

  // Verification System
  verificationVerified: "Верифицирован",
  verificationPending: "На проверке",
  verificationUnverified: "Не верифицирован",
  verificationRejected: "Отклонено",
  verificationModalTitle: "Верификация партнёра",
  verificationStep1: "Регистрационная информация",
  verificationStep2: "Загрузка документов (KYB)",
  verificationAccountType: "Тип аккаунта",
  verificationAccountTypeCorporate: "Корпоративный (法人 Hojin)",
  verificationAccountTypeIndividual: "Индивидуальный (個人 Kojin)",
  verificationAccountTypeHint:
    "Автоматически заполнено из регистрации. Корпоративный для компаний, Индивидуальный для частных лиц.",
  verificationCompanyName: "Официальное название компании",
  verificationCompanyNamePlaceholder: "напр., Tokyo Real Estate Co., Ltd.",
  verificationCompanyNameHint:
    "Официальное юридическое название вашей компании или бизнеса.",
  verificationLicenseNumber: "Номер лицензии риэлтора",
  verificationLicenseNumberHint:
    "Формат: [Префектура] Губернатор (X) № XXXXX (напр., 東京都知事 (1) 第12345号)",
  verificationCorporateEmail: "Корпоративная электронная почта",
  verificationCorporateEmailHint:
    "Должна быть корпоративная почта. Бесплатные провайдеры (Gmail, Yahoo и т.д.) не разрешены.",
  verificationOfficialWebsite: "Официальный веб-сайт (необязательно)",
  verificationOfficialWebsiteHint:
    "URL официального сайта вашей компании для верификации.",
  verificationAgencyLicense: "Лицензия агентства (宅地建物取引業者免許証)",
  verificationAgencyLicenseHint:
    "Загрузите четкое фото или скан документа лицензии агентства.",
  verificationOfficerId: "Удостоверение ответственного лица (宅地建物取引士証)",
  verificationOfficerIdHint:
    "Загрузите четкое фото пластиковой карты Takken-shi.",
  verificationUploadComingSoon:
    "Загрузка файлов скоро. Ожидается интеграция хранилища медиа.",
  verificationDocumentNote:
    "Функционал загрузки документов будет доступен после интеграции хранилища медиа. Вы можете отправить форму сейчас и загрузить документы позже.",
  note: "Примечание",
  verificationStartButton: "Начать верификацию",
  verificationNext: "Следующий шаг",
  verificationBack: "Назад",
  verificationSubmit: "Отправить на проверку",
  verificationThankYou: "Спасибо!",
  verificationThankYouMessage:
    "Ваш запрос на верификацию успешно отправлен. Наша команда рассмотрит вашу заявку и уведомит вас о решении. Обычно это занимает 1-3 рабочих дня.",
  verificationRequiredTooltip:
    "Только верифицированные риэлторы могут публиковать объявления. Пожалуйста, завершите верификацию.",
  verificationRequiredMessage:
    "Ваш аккаунт должен быть верифицирован, прежде чем вы сможете создавать объявления. Пожалуйста, завершите процесс верификации на странице профиля.",
  verificationRequests: "Запросы на верификацию",
  verificationRequestsTitle: "Запросы на верификацию партнёров",
  verificationViewDetails: "Просмотр деталей",
  verificationApprove: "Одобрить",
  verificationReject: "Отклонить",
  verificationRejectionReason: "Причина отклонения",
  verificationRejectionReasonPlaceholder:
    "напр., Скан лицензии размыт, пожалуйста, отправьте более четкое изображение",
  verificationSubmitted: "Запрос на верификацию успешно отправлен",
  verificationSubmitError: "Не удалось отправить запрос на верификацию",

  // Forgot Password Flow (on Login Page)
  forgotPassword: "Забыли пароль?",
  resetPasswordDesc:
    "Введите ваш email, и мы отправим вам ссылку для сброса пароля.",
  resetPasswordSent:
    "Если аккаунт с таким email существует, ссылка для сброса отправлена. Проверьте почту.",
  sendResetLink: "Отправить ссылку",
  enterYourEmail: "Введите ваш email",

  // Layout Descriptions (for tooltips)
  layoutDescription1R:
    "Однокомнатная квартира с кухонной зоной (без отдельной кухни)",
  layoutDescription1K: "Одна комната + отдельная кухня",
  layoutDescription1DK: "Одна комната + столовая-кухня (8+ татами)",
  layoutDescription1LDK: "Одна комната + гостиная-столовая-кухня (10+ татами)",
  layoutDescription2K: "Две комнаты + отдельная кухня",
  layoutDescription2DK: "Две комнаты + столовая-кухня",
  layoutDescription2LDK: "Две комнаты + гостиная-столовая-кухня",
  layoutDescription3K: "Три комнаты + отдельная кухня",
  layoutDescription3DK: "Три комнаты + столовая-кухня",
  layoutDescription3LDKPlus: "Три или более комнат + гостиная-столовая-кухня",

  // Photo Sections
  photoSectionFloorPlan: "План квартиры",
  photoSectionMainRoom: "Основная комната",
  photoSectionKitchenArea: "Кухонная зона",
  photoSectionBathroom: "Ванная",
  photoSectionGenkan: "Прихожая (Genkan)",
  photoSectionBedroom: "Спальня",
  photoSectionKitchen: "Кухня",
  photoSectionDiningKitchen: "Столовая-кухня",
  photoSectionLivingRoom: "Гостиная",
  photoSectionRoom1: "Комната 1",
  photoSectionRoom2: "Комната 2",
  photoSectionRoom3: "Комната 3",
  photoSectionRoom3Plus: "Дополнительные комнаты",
  photoUploadHint: "Перетащите фотографии или нажмите для выбора",
  photoUploadMax: "Максимум 10 фотографий на секцию",

  // FileUpload Component
  fileUploadDragDrop: "Перетащите файлы сюда или нажмите для выбора",
  fileUploadClick: "Нажмите для загрузки",
  fileUploadUploading: "Загрузка...",
  fileUploadError: "Ошибка загрузки",
  fileUploadInvalidType: "Недопустимый тип файла",
  fileUploadTooLarge: "Файл слишком большой",
  fileUploadMaxFiles: "Максимум {max} файлов разрешено",

  // PhotoGalleryCarousel Component
  photoGalleryScrollLeft: "Прокрутить категории влево",
  photoGalleryScrollRight: "Прокрутить категории вправо",
  photoGalleryPreviousPhoto: "Предыдущее фото",
  photoGalleryNextPhoto: "Следующее фото",
  photoGalleryNoImages: "Нет изображений для этого раздела",

  // Nearest Station Selector
  "listing.nearestStation.searching": "Поиск ближайших станций...",
  "listing.nearestStation.fetchError": "Не удалось загрузить ближайшие станции",
  "listing.nearestStation.searchError": "Ошибка поиска станций",
  "listing.nearestStation.invalidAddress":
    "Неверный адрес. Введите корректный японский адрес.",
  "listing.nearestStation.suggested": "Выберите ближайшие станции:",
  "listing.nearestStation.selected": "Выбранные станции",
  "listing.nearestStation.minWalk": "мин пешком",
  "listing.nearestStation.notYourStations": "Не ваши станции? Поиск вручную",
  "listing.nearestStation.autoSearch": "Найти ближайшие",
  "listing.nearestStation.manualSelect": "Поиск станций",
  "listing.nearestStation.searchPlaceholder": "Введите название станции...",
  "listing.nearestStation.noResults": "Станции не найдены",
  "listing.nearestStation.tryAgain": "Попробовать снова",
  "listing.nearestStation.enterAddress":
    "Введите адрес для поиска ближайших станций",

  // Find Nearby Stations
  findNearbyStations: "Найти ближайшие станции",

  // Common
  cancel: "Отмена",
  "common.close": "Закрыть",
  "common.search": "Поиск",
  "common.loading": "Загрузка...",
  "common.loadError": "Не удалось загрузить данные",
  "common.noResults": "Результаты не найдены",

  // Location Dropdown
  "listing.location.selectPrefecture": "Выберите префектуру",
  "listing.location.selectCity": "Выберите город",
  "listing.location.selectWard": "Выберите район",
  "listing.location.selectPrefectureFirst": "Сначала выберите префектуру",
  "listing.location.selectCityFirst": "Сначала выберите город",

  "listing.nearestStation.minCharsError": "Введите не менее 2 символов",
  "listing.nearestStation.loading": "Загрузка станций...",
  "listing.nearestStation.selectCityFirst": "Сначала выберите город",
  "listing.nearestStation.waitForGeocoding":
    "Идёт геокодирование адреса. Попробуйте ещё раз через некоторое время",
  "listing.location.noDataAvailable": "Нет данных",

  // Legal Documents
  termsOfUse: "Условия использования",
  partnerTerms: "Условия для партнёров",
  privacyPolicy: "Политика конфиденциальности",
  tokushoHo: "Нотация Токусё-хо",
  iAgreeToThe: "Я прочитал(а) и согласен(на) с",
  termsAcceptanceRequired: "Необходимо принять условия",
  privacyAcceptanceRequired: "Необходимо принять политику конфиденциальности",
  legalAcceptanceRequired:
    "Пожалуйста, примите все необходимые юридические документы",

  // Listing Detail Page (missing keys)
  listingDetailBackToSearch: "Назад к поиску",
  listingDetailPropertyDetails: "Детали объекта",
  listingDetailDescription: "Описание",
  listingDetailAmenities: "Удобства",
  listingDetailLocation: "Местоположение",
  listingDetailNearbyStation: "Ближайшая станция",
  listingDetailListedBy: "Опубликовано",
  listingDetailContactAgent: "Связаться",
  listingDetailVerifiedPartner: "Проверенный партнёр",
  listingDetailMonthShort: "мес",
  listingDetailManagementFee: "плата за управление",
  listingDetailBuilt: "Построен",
  listingDetailRoomLayout: "Планировка",
  listingDetailArea: "Площадь",
  listingDetailPricePerMonth: "/ месяц",
  expandFullscreen: "На весь экран",
  listingDetailNearestStations: "Ближайшие станции",
  listingDetailMinWalk: "мин пешком",
  listingDetailDeposit: "Залог",
  listingDetailKeyMoney: "Ключевые деньги",
  listingDetailGuarantorRequired: "Требуется поручитель",
  listingDetailYes: "Да",
  listingDetailNo: "Нет",
  listingDetailNotSpecified: "Не указано",
  listingDetailNotFound: "Объявление не найдено",
  listingDetailNotAvailable: "Это объявление недоступно или удалено.",
  listingDetailGoBack: "Назад",
  listingDetailLoading: "Загрузка...",
  listingDetailStationWalk: "мин пешком",
  listingDetailStation: "Станция",

  // Photo sections (for carousel display)
  detailPhotoExterior: "Экстерьер",
  detailPhotoInterior: "Интерьер",
  detailPhotoKitchen: "Кухня",
  detailPhotoBathroom: "Ванная",
  detailPhotoOther: "Прочее",

  // Listing Form - Missing Translations
  selectedStations: "Выбранные станции",
  createListingAreaRequired: "Для публикации требуется площадь (м²)",
  createListingFloorRequired: "Для публикации требуется этаж",
  createListingTotalFloorsRequired:
    "Для публикации требуется количество этажей",
  createListingYearBuiltRequired: "Для публикации требуется год постройки",
  createListingFeaturedPhoto: "Избранное фото",
  createListingSetFeatured: "Установить как избранное",
  createListingRemoveFeatured: "Убрать из избранного",
  createListingFeaturedPhotoHint:
    "Выберите фото для отображения на карточках. Если не выбрано, будет показан план квартиры.",
};

export const t = (key: keyof Locale, ...args: string[]) =>
  translate(ru, key, ...args);
